var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Link URL"},on:{"ok":_vm.handleOk},model:{value:(_vm.urlModal),callback:function ($$v) {_vm.urlModal=$$v},expression:"urlModal"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-form-input',{attrs:{"placeholder":"Enter URL"},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }